﻿
function toggleCustomRange(selectElement) {
    let relatedElementSelector = selectElement.getAttribute('date-duration');
    let relatedElement = document.querySelector(relatedElementSelector);
    if (relatedElement) {
        if (selectElement.value === 'Custom') {
            relatedElement.classList.remove('d-none');
        } else {
            relatedElement.classList.add('d-none');
        }
    }
}

export function initDateDuration() {
    let dateDurationSelects = document.querySelectorAll('[date-duration]');
    dateDurationSelects.forEach(function(selectElement) {
        selectElement.addEventListener('change', function() {
            toggleCustomRange(selectElement);
        });
        toggleCustomRange(selectElement); // Initialize on page load
    });
}